// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file message/message_errors.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file message/message_errors.proto.
 */
export const file_message_message_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChxtZXNzYWdlL21lc3NhZ2VfZXJyb3JzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCKPAgoMTWVzc2FnZUVycm9yGiEKH0hhc05vUGVybWlzc2lvbnNUb1VwZGF0ZU1lc3NhZ2UaFQoTTWVzc2FnZURvZXNOb3RFeGlzdBobChlNYXhBbGJ1bUl0ZW1zTGltaXRSZWFjaGVkGiEKH1JlYWN0T25TeXN0ZW1NZXNzYWdlSXNGb3JiaWRkZW4aGQoXQ2hhdFR5cGVJc05vdEFwcGxpY2FibGUaGAoWVW5zdXBwb3J0ZWRQYXlsb2FkVHlwZRoZChdRdW90ZWRNZXNzYWdlSXNOb3RFeGlzdBobChlVbmFibGVUb0NyZWF0ZUxpbmtQcmV2aWV3GhgKFkUyZWVDb21taXRTeW5jUmVxdWlyZWRCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.MessageError
 */
export type MessageError = Message<'com.gem.bff.contract.MessageError'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.
 * Use `create(MessageErrorSchema)` to create a new message.
 */
export const MessageErrorSchema: GenMessage<MessageError> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0);

/**
 * E_HAS_NO_PERMISSIONS_TO_UPDATE_MESSAGE
 *
 * @generated from message com.gem.bff.contract.MessageError.HasNoPermissionsToUpdateMessage
 */
export type MessageError_HasNoPermissionsToUpdateMessage =
  Message<'com.gem.bff.contract.MessageError.HasNoPermissionsToUpdateMessage'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.HasNoPermissionsToUpdateMessage.
 * Use `create(MessageError_HasNoPermissionsToUpdateMessageSchema)` to create a new message.
 */
export const MessageError_HasNoPermissionsToUpdateMessageSchema: GenMessage<MessageError_HasNoPermissionsToUpdateMessage> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 0);

/**
 * E_MESSAGE_DOESNT_EXIST
 *
 * @generated from message com.gem.bff.contract.MessageError.MessageDoesNotExist
 */
export type MessageError_MessageDoesNotExist =
  Message<'com.gem.bff.contract.MessageError.MessageDoesNotExist'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.MessageDoesNotExist.
 * Use `create(MessageError_MessageDoesNotExistSchema)` to create a new message.
 */
export const MessageError_MessageDoesNotExistSchema: GenMessage<MessageError_MessageDoesNotExist> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 1);

/**
 * E_MAX_ALBUM_ITEMS_REACHED
 *
 * @generated from message com.gem.bff.contract.MessageError.MaxAlbumItemsLimitReached
 */
export type MessageError_MaxAlbumItemsLimitReached =
  Message<'com.gem.bff.contract.MessageError.MaxAlbumItemsLimitReached'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.MaxAlbumItemsLimitReached.
 * Use `create(MessageError_MaxAlbumItemsLimitReachedSchema)` to create a new message.
 */
export const MessageError_MaxAlbumItemsLimitReachedSchema: GenMessage<MessageError_MaxAlbumItemsLimitReached> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 2);

/**
 * E_REACT_ON_SYSTEM_MESSAGE_IS_FORBIDDEN
 *
 * @generated from message com.gem.bff.contract.MessageError.ReactOnSystemMessageIsForbidden
 */
export type MessageError_ReactOnSystemMessageIsForbidden =
  Message<'com.gem.bff.contract.MessageError.ReactOnSystemMessageIsForbidden'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.ReactOnSystemMessageIsForbidden.
 * Use `create(MessageError_ReactOnSystemMessageIsForbiddenSchema)` to create a new message.
 */
export const MessageError_ReactOnSystemMessageIsForbiddenSchema: GenMessage<MessageError_ReactOnSystemMessageIsForbidden> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 3);

/**
 * E_CHAT_TYPE_IS_NOT_APPLICABLE
 *
 * @generated from message com.gem.bff.contract.MessageError.ChatTypeIsNotApplicable
 */
export type MessageError_ChatTypeIsNotApplicable =
  Message<'com.gem.bff.contract.MessageError.ChatTypeIsNotApplicable'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.ChatTypeIsNotApplicable.
 * Use `create(MessageError_ChatTypeIsNotApplicableSchema)` to create a new message.
 */
export const MessageError_ChatTypeIsNotApplicableSchema: GenMessage<MessageError_ChatTypeIsNotApplicable> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 4);

/**
 * E_UNSUPPORTED_PAYLOAD_TYPE
 *
 * @generated from message com.gem.bff.contract.MessageError.UnsupportedPayloadType
 */
export type MessageError_UnsupportedPayloadType =
  Message<'com.gem.bff.contract.MessageError.UnsupportedPayloadType'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.UnsupportedPayloadType.
 * Use `create(MessageError_UnsupportedPayloadTypeSchema)` to create a new message.
 */
export const MessageError_UnsupportedPayloadTypeSchema: GenMessage<MessageError_UnsupportedPayloadType> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 5);

/**
 * E_QUOTED_MESSAGE_IS_NOT_EXIST
 *
 * @generated from message com.gem.bff.contract.MessageError.QuotedMessageIsNotExist
 */
export type MessageError_QuotedMessageIsNotExist =
  Message<'com.gem.bff.contract.MessageError.QuotedMessageIsNotExist'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.QuotedMessageIsNotExist.
 * Use `create(MessageError_QuotedMessageIsNotExistSchema)` to create a new message.
 */
export const MessageError_QuotedMessageIsNotExistSchema: GenMessage<MessageError_QuotedMessageIsNotExist> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 6);

/**
 * E_UNABLE_TO_CREATE_LINK_PREVIEW
 *
 * @generated from message com.gem.bff.contract.MessageError.UnableToCreateLinkPreview
 */
export type MessageError_UnableToCreateLinkPreview =
  Message<'com.gem.bff.contract.MessageError.UnableToCreateLinkPreview'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.UnableToCreateLinkPreview.
 * Use `create(MessageError_UnableToCreateLinkPreviewSchema)` to create a new message.
 */
export const MessageError_UnableToCreateLinkPreviewSchema: GenMessage<MessageError_UnableToCreateLinkPreview> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 7);

/**
 * E_COMMIT_SYNC_REQUIRED
 *
 * @generated from message com.gem.bff.contract.MessageError.E2eeCommitSyncRequired
 */
export type MessageError_E2eeCommitSyncRequired =
  Message<'com.gem.bff.contract.MessageError.E2eeCommitSyncRequired'> & {};

/**
 * Describes the message com.gem.bff.contract.MessageError.E2eeCommitSyncRequired.
 * Use `create(MessageError_E2eeCommitSyncRequiredSchema)` to create a new message.
 */
export const MessageError_E2eeCommitSyncRequiredSchema: GenMessage<MessageError_E2eeCommitSyncRequired> =
  /*@__PURE__*/
  messageDesc(file_message_message_errors, 0, 8);
